// extracted by mini-css-extract-plugin
export default {"select":"nw9prH7O"};